<template>
    <div class="h-100">
        <app-loader v-if="pageLoader"></app-loader>
        <div class="wt-dashborad-chart-header advanced-seat-tab-content-header d-flex justify-content-between align-items-center mt-4 mb-2">
            <!-- <input class="switch-toggle-checkbox" type="checkbox" id="pricing-plan-switch"/>
            <label class="switch-toggle-label" for="pricing-plan-switch">
                <span v-for="(profit_j,index) in profitJson" :key="index" @click.prevent="changeTradingProfitTab(index)">{{ index }}</span>
            </label> -->
            <ul class="switch-toggle d-flex align-items-center p-0" id="myTab" role="tablist">
                <li class="nav-item switch-toggle-label ml-2" v-for="(profit_j,index) in profitJson" :key="index">
                    <a class="nav-link"   v-bind:class="{'active':tradingProfitTab == index}" id="usd-tab" data-toggle="tab" href="javascript:void(0);" role="tab" aria-controls="usd" aria-selected="true"
                        @click.prevent="changeTradingProfitTab(index)"
                    >{{ index }}</a>
                </li>
            </ul>
            <div class="dropdown dark-dropdown">
                <button class="btn dropdown-toggle f-14" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{ performanceFilter }}
                </button>
                <div class="dropdown-menu mt-1 w-100" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="javascript:void(0);" v-text="performance" v-for=" (performance,index)  in performanceFilterJson" :key="index" @click="setPerformanceFilter(performance)"></a>
                </div>
            </div>
        </div>
        <div class="wt-dashborad-chart-box" v-show="(Object.keys(performanceChartData).length && performanceChartData.series.length && performanceChartData.series[0].data.length) ">
            <div id="trader_perfomance" class="performance" ></div>

        </div>
        <div v-if="!(Object.keys(performanceChartData).length && performanceChartData.series.length && performanceChartData.series[0].data.length) " class="nodataFound position-relative">
            <div class="boxedNodata h-100 d-flex align-items-center justify-content-center">
                <div class="noDataPic">
                    <img src="../../../../../../static/website/images/no-data.svg" alt="" />
                    <!-- <span class="f-16">No trading history found.</span> -->
                </div>
                <!-- <p class="f-16 bold">No Data Found</p> -->
            </div>
            <!-- <img src="../../../../../static/hanko/images/new/errorGraphCandle.png" alt="graph" /> -->
        </div>
        <div class="d-flex justify-content-between align-items-center mt-3 mb-2" v-if="(Object.keys(performanceChartData).length && performanceChartData.series.length && performanceChartData.series[0].data.length) ">
            <div class="wt-dashborad-chart-footer">
                <ul class="d-flex align-items-center p-0">
                    <li v-for="item,key in dateDrop" @click.prevent.stop="dateDropSelected = key" :class="{'active':dateDropSelected == key}">{{ item }}</li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
import * as am4core from "../../../../../../node_modules/@amcharts/amcharts4/core"
import * as am4charts from "../../../../../../node_modules/@amcharts/amcharts4/charts"
import am4themes_animated from "../../../../../../node_modules/@amcharts/amcharts4/themes/animated"

import { commonAllmixins } from "@/plugins/commonAll";

export default {
    emits:['updateSelectedTimeFrame'],
    props:['dateDrop','dateDropSelected'],
    mixins: [commonAllmixins],
    data:function(){
        return {
            performanceFilter : 'Include Unrealized PnL',
            performanceFilterJson:  {
                0 : 'Include Unrealized PnL',
                1 : 'Closed Trades Only',
                2 : 'Trade Volume',
                3 : 'By Pair',
                4 : 'Best-Worst',
                5 : 'Ranking',
            },
            tradingProfitTab :  'USD',
            performancelabeljson : {
                'Include Unrealized PnL' : {
                    0 : 'Total PnL',
                    1 : 'Unrealised PnL'
                },
                'Closed Trades Only' : {
                    0 : this.tradingProfitTab != 'Pips' ? this.leaderDetail && this.leaderDetail.trader && this.leaderDetail.trader.stats &&  this.leaderDetail.trader.stats.profile && this.leaderDetail.trader.stats.profile.baseCurrencyName : 'Pips'
                },
                'Trade Volume' : {
                    0 : 'Win',
                    1 : 'Lose',
                    2 : 'Break-Even'
                },
                'Best-Worst' : {
                    0 : 'Best Trade',
                    1 : 'Worst Trade'
                },
                'Ranking' : {
                    0 : 'Ranking'
                }
            },
            profitJson : {
                'USD' : 'USD',
                'Pips' : 'pips',
                // 'ROI' : '%'
            },
            xAxisColor:'#666666',
            yAxisColor:'#404d7b',
            leader_id:'',
            pageLoader : false,
            chart:null
        }
    },
    watch:{
        'dateDropSelected':function(){
            this.getTraderPerformanceData();
        }
    },
    mounted(){
        this.getTraderPerformanceData();
    },

    methods:{
        drawBestWorstPerformaceChart() {
            // Destroy existing chart instance if any
            if (this.chart) {
                this.chart.dispose();
            }

            // Create chart instance
            let chart = am4core.create("trader_perfomance", am4charts.XYChart);

            // Set themes
            am4core.useTheme(am4themes_animated);
            // am4core.useTheme(am4themes_responsive);

            // Configure number formatter if performanceFilter is 'Ranking'
            if (this.performanceFilter == 'Ranking') {
                chart.numberFormatter.numberFormat = "#a";
                chart.numberFormatter.smallNumberThreshold = 0.001;
            }

            // Create axes
            let xAxis = chart.xAxes.push(new am4charts.DateAxis());
            xAxis.baseInterval = { timeUnit: "day", count: 1 };
            xAxis.renderer.minGridDistance = 70;
            // Hide the x-axis line
            xAxis.renderer.line.strokeOpacity = 0;
            xAxis.renderer.line.disabled = true;
            let label2 = chart.plotContainer.createChild(am4core.Label);
            label2.text = "[#" + this.xAxisColor + "] Date [/]";
            label2.fontSize = 12;
            label2.align = "center";
            label2.valign = "bottom";
            label2.dy = 40;

            let yAxis;
            if (this.performanceFilter == 'Ranking') {
                yAxis = chart.yAxes.push(new am4charts.ValueAxis());
                yAxis.renderer.inversed = true;
            } else {
                yAxis = chart.yAxes.push(new am4charts.ValueAxis());
            }
            yAxis.renderer.line.strokeOpacity = 0;
            xAxis.renderer.grid.template.disabled = true;
            yAxis.renderer.grid.template.disabled = true;
            yAxis.renderer.baseGrid.disabled = true;

            //to disable tooltip over xaxis and yaxis
            xAxis.cursorTooltipEnabled = false;
            yAxis.cursorTooltipEnabled = false;


            let label1 = chart.plotContainer.createChild(am4core.Label);
            label1.rotation = -90;
            label1.text = this.performanceFilter == 'Ranking' ?
                        "[#" + this.xAxisColor + "] Ranking [/]" :
                        "[#" + this.xAxisColor + "] Best and Worst Trade [/]";
            label1.fontSize = 12;
            label1.x = -50;
            label1.y = 180;
            // label1.halign = "left";
            // label1.align = "center";

            // Add cursor
            let cursor = new am4charts.XYCursor();
            cursor.behavior = "zoomX";
            cursor.lineY.disabled = true;
            cursor.lineX.disabled = true;
            chart.cursor = cursor;

            // Create series
            this.performanceChartData.series.forEach((val, index) => {
                if (val.data.length) {
                    let series = chart.series.push(new am4charts.LineSeries());
                    series.dataFields.valueY = "y";
                    series.dataFields.dateX = "x";
                    series.name = this.performancelabeljson[this.performanceFilter][index];
                    series.tooltipText = "{dateX.formatDate('dd MMM yyyy')}: {valueY}";
                    series.strokeWidth = 2;
                    series.data = val.data;
                    // chart.legend.data.push(series);
                    series.appear(1000);
                }
            });

            // Add legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.labels.template.fontSize = 12;
            chart.legend.labels.template.fontWeight = "600";
            chart.legend.markers.template.width = 13;
            chart.legend.markers.template.height = 13;
            // chart.legend.markers.template.cornerRadius(20, 20, 20, 20);


            // Apply color settings
            chart.colors.list = [
                am4core.color(0x8dedc8),
                am4core.color(0x404d7b)
            ];

            xAxis.renderer.labels.template.fill = am4core.color(this.xAxisColor);
            xAxis.renderer.labels.template.fontSize = 12;
            yAxis.renderer.labels.template.fill = am4core.color(this.yAxisColor);
            yAxis.renderer.labels.template.fontSize = 12;

            // Animate on load
            chart.hiddenState.properties.opacity = 0;
            chart.hiddenState.properties.visible = false;

            this.chart = chart;
        },

        drawPairsPerformanceChart() {
            // Destroy existing chart instance if any
            if (this.chart) {
                this.chart.dispose();
            }

            // Create chart instance
            let chart = am4core.create("trader_perfomance", am4charts.XYChart);

            // Set themes
            am4core.useTheme(am4themes_animated);
            // am4core.useTheme(am4themes_responsive);

            // Create axes
            let xAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            xAxis.dataFields.category = "x";
            xAxis.renderer.minGridDistance = 70;

            let label2 = chart.plotContainer.createChild(am4core.Label);
            label2.text = "[#" + this.xAxisColor + "] Currency Pairs [/]";
            label2.fontSize = 12;
            label2.align = "center";
            label2.valign = "bottom";
            label2.dy = 40;

            let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
            yAxis.renderer.minWidth = 35;
            xAxis.renderer.grid.template.disabled = true;
            yAxis.renderer.grid.template.disabled = true;

            //to disable tooltip over xaxis and yaxis
            xAxis.cursorTooltipEnabled = false;
            yAxis.cursorTooltipEnabled = false;

            let label1 = chart.plotContainer.createChild(am4core.Label);
            label1.rotation = -90;
            label1.text = this.tradingProfitTab == 'Pips' ?
                        "[#" + this.xAxisColor + "] Profit (Pips)" :
                        "[#" + this.xAxisColor + "] Profit (" + this.leaderDetail.trader.stats.profile.baseCurrencyName + ")";
            label1.fontSize = 12;
            label1.x = -70;
            label1.y = 120;



            // Create series
            let series = chart.series.push(new am4charts.ColumnSeries());
            series.dataFields.valueY = "y";
            series.dataFields.categoryX = "x";
            series.stroke = am4core.color("#079C77");
            series.fill = am4core.color("#079C77");
            series.name = "[#" + this.xAxisColor + "] Profit (" + this.tradingProfitTab + ")";
            series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
            series.columns.template.fillOpacity = 0.8;

            let columnTemplate = series.columns.template;
            columnTemplate.strokeWidth = 2;
            columnTemplate.strokeOpacity = 1;

            // Add legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.labels.template.fontSize = 12;
            chart.legend.labels.template.fontWeight = "600";

            // Set data
            chart.data = this.performanceChartData.series[0].data;

            // Apply color settings
            chart.colors.list = [
                am4core.color(0x8dedc8)
            ];

            xAxis.renderer.labels.template.fill = am4core.color(this.xAxisColor);
            xAxis.renderer.labels.template.fontSize = 12;
            yAxis.renderer.labels.template.fill = am4core.color(this.yAxisColor);
            yAxis.renderer.labels.template.fontSize = 12;

            // Animate on load
            chart.hiddenState.properties.opacity = 0;
            chart.hiddenState.properties.visible = false;
            series.hiddenState.properties.opacity = 0;
            series.hiddenState.properties.visible = false;

            this.chart = chart;
        },
        drawPerformanceChart() {
            try {
            // Destroy existing chart instance if any
            if (this.chart) {
                this.chart.dispose();
            }

            // Create chart instance
            let chart = am4core.create("trader_perfomance", am4charts.XYChart);
            // Set themes
            am4core.useTheme(am4themes_animated);
            // am4core.useTheme(am4themes_responsive);
            // if (this.auth_store.mode == 'dark') {
            //     am4core.useTheme(am4themes_dark);
            // }

            // Create axes
            let xAxis = chart.xAxes.push(new am4charts.DateAxis());
            xAxis.baseInterval = { timeUnit: "month", count: 1 };
            xAxis.renderer.minGridDistance = 70;
            xAxis.renderer.line.strokeOpacity = 0;


            let label2 = chart.plotContainer.createChild(am4core.Label);
            label2.text = "[#" + this.xAxisColor + "] Date [/]";
            label2.fontSize = 12;
            label2.align = "center";
            label2.valign = "bottom";
            label2.dy = 40;

            let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
            xAxis.renderer.grid.template.disabled = true;
            yAxis.renderer.grid.template.disabled = true;

            //to disable tooltip over xaxis and yaxis
            xAxis.cursorTooltipEnabled = false;
            yAxis.cursorTooltipEnabled = false;

            let json = {};
            if (this.performanceFilter == 'Trade Volume') {
                json = {
                    rotation: -90,
                    y: am4core.percent(50),
                    text: "[#" + this.xAxisColor + "] Number of Trades [/]",
                    centerX: am4core.percent(50),
                    fontSize: 12,
                };
            } else {
                if (this.tradingProfitTab == this.leaderDetail.trader.stats.profile.baseCurrencyName) {
                    json = {
                        rotation: -90,
                        y: am4core.percent(50),
                        text: "[#" + this.xAxisColor + "] " + this.leaderDetail.trader.stats.profile.baseCurrencyName,
                        // fill: am4core.color(0x666666),
                        centerX: am4core.percent(50),
                        fontSize: 12,
                    };
                } else if (this.tradingProfitTab == 'Pips') {
                    json = {
                        rotation: -90,
                        y: am4core.percent(50),
                        text: "[#" + this.xAxisColor + "] Pips [/]",
                        centerX: am4core.percent(50),
                        fontSize: 12,
                    };
                }
            }

            let label1 = chart.plotContainer.createChild(am4core.Label);
            label1.text = json.text;
            label1.rotation = json.rotation;
            label1.y = json.y;
            label1.fill = json.fill || am4core.color("#000");
            // label1.align = "center";
            label1.fontSize = json.fontSize;
            label1.x = -60;

            // label1.y = 0;

            // Add cursor
            let cursor = new am4charts.XYCursor();
            cursor.behavior = "zoomX";
            cursor.lineY.disabled = true;
            cursor.lineX.disabled = true;
            chart.cursor = cursor;


             // Create series
            this.performanceChartData.series.forEach((val, index) => {
                if (val.data.length) {
                    let series = chart.series.push(new am4charts.ColumnSeries());
                    series.dataFields.valueY = "y";
                    series.dataFields.dateX = "x";
                    series.name = this.performanceFilter == 'Closed Trades Only' ?
                                (this.tradingProfitTab == 'Pips' ? 'Pips' : this.leaderDetail.trader.stats.profile.baseCurrencyName) :
                                this.performancelabeljson[this.performanceFilter][index];
                    series.tooltipText = "{dateX.formatDate('dd MMM yyyy')}: {valueY}";
                    series.strokeWidth = 2;
                    series.stroke = am4core.color("#079C77");
                    series.fill = am4core.color("#079C77");
                    series.data = val.data;
                    series.appear(1000);
                }
            });


            // Add legend
            chart.legend = new am4charts.Legend();
            chart.legend.position = "bottom";
            chart.legend.labels.template.fontSize = 12;
            chart.legend.labels.template.fontWeight = "600";
            chart.legend.markers.template.width = 13;
            chart.legend.markers.template.height = 13;
            // chart.legend.markers.template.cornerRadius(20, 20, 20, 20);


            // Apply color settings
            chart.colors.list = [
                am4core.color(0x575cde),
                am4core.color(0xdec457),
                am4core.color(0xdec457)
            ];

            xAxis.renderer.labels.template.fill = am4core.color(this.xAxisColor);
            xAxis.renderer.labels.template.fontSize = 12;
            yAxis.renderer.labels.template.fill = am4core.color(this.yAxisColor);
            yAxis.renderer.labels.template.fontSize = 12;

            // Animate on load
            chart.hiddenState.properties.opacity = 0;
            chart.hiddenState.properties.visible = false;


            this.chart = chart;
        }
        catch(error){
            console.log(error);
        };
        },
        getTraderPerformanceData(){
            let formData = {};
            let type = ''

            // chnage color according to theme
            // if(this.auth_store.mode == 'dark'){
            //     this.xAxisColor = '#FFFFFF';
            //     this.yAxisColor = '#FFFFFF';
            // }
            // else{
            //     this.xAxisColor ='#666666';
            //     this.yAxisColor ='#404d7b';
            // }
            if(this.performanceFilter == 'Include Unrealized PnL' && this.tradingProfitTab == (this.leaderDetail && this.leaderDetail.trader && this.leaderDetail.trader.stats &&  this.leaderDetail.trader.stats.profile && this.leaderDetail.trader.stats.profile.baseCurrencyName)){
                type = 'TOTAL_PROFIT_MONEY,OPEN_PROFIT_MONEY'
            }else if(this.performanceFilter == 'Include Unrealized PnL' && this.tradingProfitTab == 'Pips'){
                type = 'TOTAL_PROFIT,OPEN_PROFIT'
            }else if(this.performanceFilter == 'Closed Trades Only' && this.tradingProfitTab == (this.leaderDetail && this.leaderDetail.trader && this.leaderDetail.trader.stats &&  this.leaderDetail.trader.stats.profile && this.leaderDetail.trader.stats.profile.baseCurrencyName)){
                type = 'CLOSED_PROFIT_MONEY'
            }else if(this.performanceFilter == 'Closed Trades Only' && this.tradingProfitTab == 'Pips'){
                type = 'CLOSED_PROFIT'
            }else if(this.performanceFilter == 'Trade Volume'){
                type = 'WIN_TRADES,LOSE_TRADES,BREAK_EVEN_TRADES'
            }else if(this.performanceFilter == 'By Pair' && this.tradingProfitTab == (this.leaderDetail && this.leaderDetail.trader && this.leaderDetail.trader.stats &&  this.leaderDetail.trader.stats.profile && this.leaderDetail.trader.stats.profile.baseCurrencyName)){
                type = 'CURRENCY_CLOSED_PROFIT_MONEY'
            }else if(this.performanceFilter == 'By Pair' && this.tradingProfitTab == 'Pips'){
                type = 'CURRENCY_CLOSED_PROFIT'
            }else if(this.performanceFilter == 'Best-Worst'){
                type = 'BEST_TRADE,WORST_TRADE'
            }else if(this.performanceFilter == 'Ranking'){
                type = 'RANKING'
            }

            this._runGetPerformanceChartData({ globalParams: {}, localParams: { provider_id: this.divide9(this.$route.query.id), type: type || 'TOTAL_PROFIT_MONEY,OPEN_PROFIT_MONEY', timeframe: this.dateDropSelected, parameter: this } })
                // console.log("performanceChartData",this.performanceChartData.data)


            // this.performanceChartDataData(formData,true,this.leader_id,this.dateDropSelected,type)

        },
        drawPerformanceChartDecision(){
            if(Object.keys(this.performanceChartData).length && this.performanceChartData.series && this.performanceChartData.series.length > 0){
                if(this.performanceFilter == 'By Pair'){
                    this.drawPairsPerformanceChart()
                }else if(this.performanceFilter == 'Best-Worst' || this.performanceFilter == 'Ranking'){
                    this.drawBestWorstPerformaceChart()
                }else{
                    this.drawPerformanceChart()
                }
            }
        },
        addQueryInRoute() {
            this.$router.push({ path: this.$route.path, query: { t: this.dateDropSelected, m: 1 } });
        },
        setTimeframe(date_drop){
            this.$emit('updateSelectedTimeFrame',date_drop)
        },
        destroyChart(){
            let chartElement = am4core.registry.baseSprites.find((sprite) => sprite.htmlContainer.id === "trader_perfomance");
            if (chartElement) {
                chartElement.dispose();
            }
        },
        setPerformanceFilter(performance){
            this.performanceFilter = performance;
            this.getTraderPerformanceData();

        },

        changeTradingProfitTab(tab){
            this.tradingProfitTab = tab;
            this.getTraderPerformanceData();
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/website/copy-trade/leader-detail/Charts/performance-chart.vue